import { useEffect } from 'react';
import { motion } from 'framer-motion';
import styles from './DayBook.module.css';

import { useState } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { Button, Box, TablePagination } from '@mui/material';
import { allTransactionListApi } from 'utils/API/SuperdistributorEmployee APIs/SuperdistributorApiCalls';

import { LoadingButton } from '@mui/lab';

const TransactionList = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0); // from API
    const [loading, setLoading] = useState(false);

    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());

    const [transactions, setTransactions] = useState([]);

    const fetchTransactions = async (page = currentPage, size = pageSize) => {
        setLoading(true);
        try {
            const payload = {
                fromDate: fromDate.toISOString().split('T')[0],
                toDate: toDate ? toDate.toISOString().split('T')[0] : '',
                pageSize: size.toString(),
                pageNumber: page.toString()
            };

            const res = await allTransactionListApi(payload);

            setTransactions(res.data?.data || []);
            setTotalCount(res.data?.count || 0); // <- Add this line
        } catch (err) {
            console.error('Error fetching transactions', err);
        } finally {
            setLoading(false); // Set loading to false when fetch completes (success or error)
        }
    };
    useEffect(() => {
        fetchTransactions(currentPage, pageSize);
        // eslint-disable-next-line
    }, [currentPage, pageSize]);
    const handleRowsPerPageChange = (event) => {
        setPageSize(parseInt(event.target.value, 10));
        setCurrentPage(1); // Reset to the first page when rows per page changes
    };
    const handlePageChange = (event, newPage) => {
        // TablePagination is 0-indexed, so we add 1 for our 1-indexed state
        setCurrentPage(newPage + 1);
    };

    return (
        <div className={styles.container}>
            <Box sx={{ padding: 2 }}>
                {/* First Section: Day Book & Pending Approvals */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'space-between', // space between left and right groups
                        alignItems: { xs: 'stretch', sm: 'center' },
                        flexWrap: 'wrap',
                        gap: 2,
                        mb: 3
                    }}
                >
                    {/* Left Side: Day Book & Pending Approvals */}
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        <Button variant="contained" disableElevation className={styles.daybookbtn}>
                            Transaction List
                        </Button>
                    </Box>
                </Box>

                {/* Second Section: Date Picker + Submit */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { sm: 'center' },
                        gap: 2,
                        mb: 3
                    }}
                >
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Box display="flex" gap={2}>
                            <DatePicker
                                label="From Date"
                                value={fromDate}
                                onChange={(newValue) => setFromDate(newValue)}
                                maxDate={new Date()}
                                slotProps={{
                                    textField: {
                                        size: 'small',
                                        variant: 'outlined',
                                        sx: { width: '180px' }
                                    }
                                }}
                            />
                            <DatePicker
                                label="To Date"
                                value={toDate}
                                onChange={(newValue) => setToDate(newValue)}
                                minDate={fromDate}
                                maxDate={new Date()}
                                slotProps={{
                                    textField: {
                                        size: 'small',
                                        variant: 'outlined',
                                        sx: { width: '180px' }
                                    }
                                }}
                            />
                        </Box>
                    </LocalizationProvider>

                    <LoadingButton onClick={() => fetchTransactions(1, pageSize)} className={styles.addClientButton} loading={loading}>
                        Submit
                    </LoadingButton>
                </Box>

                {/* ...Your table and remaining content... */}
            </Box>

            <motion.div
                className={styles.tableSection}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.5 }}
            >
                <Box className={styles.tabContent}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>Sl. No.</th>
                                <th>Payment Mode</th>
                                <th>Transaction Date</th>
                                <th>To</th>
                                <th>From</th>
                                <th>Opening Balance</th>
                                <th>Closing Balance</th>
                                <th>Amount</th>

                                <th>Created Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(transactions) &&
                                transactions.map((tx, index) => (
                                    <tr key={index}>
                                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                                        <td>{tx.payment_mode}</td>
                                        <td>{tx.date_of_txn?.slice(0, 10)}</td>
                                        <td>{tx.to_entity_name || tx.to || 'myself'}</td>
                                        <td>{tx.from_entity_name || tx.from || 'myself'}</td>

                                        <td>{tx.opening_balance}</td>
                                        <td>{tx.closing_balance}</td>
                                        <td>{tx.amount}</td>

                                        <td>{tx.created_at?.slice(0, 10)}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={pageSize}
                        page={currentPage - 1} // TablePagination is 0-indexed
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleRowsPerPageChange}
                        sx={{
                            marginTop: 2,
                            display: 'flex',
                            justifyContent: 'flex-end',
                            borderTop: '1px solid #e0e0e0',
                            paddingTop: '8px'
                        }}
                    />
                </Box>
            </motion.div>
        </div>
    );
};

export default TransactionList;
